import { ICardCommercialOffersGenerateDoc } from './types'

import { Button, Divider, Empty, Flex, Loader, Modal, Table } from '@ui/index'

import { IconClearClose } from '@img/icons'
import imgEmty from '@img/empty.svg'


/** Создание документов по коммерческому предложению */
export const CardCommercialOffersGenerateDoc = ({
    isOpen, isLoading, documentsList,
    handleSelectedDocuments, handleBtnSave, handleButtonCancel
}: ICardCommercialOffersGenerateDoc) => {
    return <>
        <Modal isOpen={isOpen} isEsc onCancel={handleButtonCancel} overflowY="hidden" maxWidth="350px">
            <Flex className='modal_container'>
                <Flex flexDirection="row" alignItems="center" justifyContent="space-between" className='modal_container-header'>
                    <h4>Выбор документов</h4>

                    <Button variant='icon' size='xs' onClick={handleButtonCancel}>
                        <IconClearClose />
                    </Button>
                </Flex>

                <Flex gap='4px' className='modal_container-body'>
                    <Flex className='modal_container-content'>
                        <Loader isOpen={isLoading} backdrop color='green' title='Загрузка...' />

                        <Table.Content gap="4px" minHeight='100px' isScrollVertical={false}>
                            {documentsList.value.length === 0
                                ? <Empty image={imgEmty} />
                                : documentsList.value.map((item, index) => (
                                    <Table.RowCheckBox key={index + 1}
                                        header={index + 1} headerWidth="40px"
                                        isSelected={item.isSelect}
                                        onClick={() => handleSelectedDocuments(item.id)}
                                    >
                                        <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                            <p>{item.name}</p>
                                        </div>
                                    </Table.RowCheckBox>
                                ))
                            }
                        </Table.Content>
                    </Flex>

                    <Divider />
                    <Button width='100%' onClick={handleBtnSave}>Сформировать</Button>
                </Flex>
            </Flex>
        </Modal>
    </>
}